import type { Locale } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute } from "../../api"
import type { DocumentResponse } from "../../common"

export interface GeneratePriceTagPathParams {
	inventoryId: string
	languageTag: Locale
}
export interface GeneratePriceTagBody {
	allowedOptionNames: string[]
}
export interface GeneratePriceTagQuery {
	withCrest?: "true" | "false"
	withFsOffer?: "true" | "false"
}
export const generatePriceTagRoute: ApiRoute<
	GeneratePriceTagPathParams,
	GeneratePriceTagQuery,
	GeneratePriceTagBody,
	DocumentResponse
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/pricetag/${params.languageTag}`,
	method: "post",
	path: "/vehicles/:inventoryId/pricetag/:languageTag",
}
